const DEFAULT_PROMISE_TIMEOUT = 1000

/**
 * Execute a promise but fail if it doesn't complete within an aol
 * @typedef {Object} TimeoutFuncOpts (extends http.RequestOptions)
 * @property {number} timeout
 * @property {Promise} promise
 * @property {() => Error} onTimeoutError
 *
 * @param {TimeoutFuncOpts} options
 * @returns {Promise} The completing promise, or the rejecting timeout
 */
const promiseWithTimeout = ({ timeout = DEFAULT_PROMISE_TIMEOUT, promise, onTimeoutError }) => {
  let id
  return Promise.race([
    promise.then(value => {
      // ensure we clear the timeout on success so we don't reject after resolve
      clearTimeout(id)
      return value
    }),
    new Promise((_resolve, reject) => {
      id = setTimeout(() => {
        clearTimeout(id)
        reject(onTimeoutError())
      }, timeout)
    })
  ])
}

module.exports = {
  promiseWithTimeout
}
